@if (!showLoader && !isShowRenewalPopup) {
  <h1 class="login-failed-title" tabindex="0">
    {{ loginFailedService.message }}
  </h1>
}
@if (isShowRenewalPopup) {
  <app-renewal-popup [userProfile]="userProfile"></app-renewal-popup>
}
@if (showLoader) {
  <app-loader></app-loader>
}
